'use client';

import { useCallback, useEffect, useRef } from 'react';

/**
 * Закрытие модалки по Escape и клику по затемнённому фону (не по содержимому).
 * onClose берётся из ref, чтобы не снимать слушатель при каждом рендере.
 */
export function useModalOverlayDismiss(isOpen: boolean, onClose: () => void) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCloseRef.current();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen]);

  const onBackdropPointerDown = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onCloseRef.current();
  }, []);

  return { onBackdropPointerDown };
}
